import { MerchantGeneralSettingsResponse, PutMerchantGeneralSettingsRequest } from 'APIs/merchants/merchants.types';
import { divideBy100, formatAmount, minorCurrencyUnits } from 'utils/currency';

export type UpdateCheckoutLimitsFormProps = {
  minLimit: string;
  useSysDefaultMinLimit: boolean;
  maxLimit: string;
  useSysDefaultMaxLimit: boolean;
};

type ToPutMerchantGeneralSettingsRequest = (
  merchantGeneralSettings: MerchantGeneralSettingsResponse,
  updateCheckoutLimitsForm: UpdateCheckoutLimitsFormProps,
) => PutMerchantGeneralSettingsRequest;
type ToUpdateCheckoutLimitsFormProps = (
  merchantGeneralSettings: MerchantGeneralSettingsResponse,
) => UpdateCheckoutLimitsFormProps;

export const toPutMerchantGeneralSettingsRequest: ToPutMerchantGeneralSettingsRequest = (
  merchantGeneralSettings: MerchantGeneralSettingsResponse,
  updateCheckoutLimitsForm: UpdateCheckoutLimitsFormProps,
): PutMerchantGeneralSettingsRequest => {
  return {
    ...merchantGeneralSettings,
    payInFullMinCheckoutLimit: updateCheckoutLimitsForm.useSysDefaultMinLimit
      ? undefined
      : minorCurrencyUnits(Number(updateCheckoutLimitsForm.minLimit)),
    payInFullMaxCheckoutLimit: updateCheckoutLimitsForm.useSysDefaultMaxLimit
      ? undefined
      : minorCurrencyUnits(Number(updateCheckoutLimitsForm.maxLimit)),
  };
};

export const toUpdateCheckoutLimitsFormProps: ToUpdateCheckoutLimitsFormProps = (
  merchantGeneralSettings: MerchantGeneralSettingsResponse,
): UpdateCheckoutLimitsFormProps => {
  return {
    minLimit: formatAmount(divideBy100(merchantGeneralSettings.payInFullMinCheckoutLimit ?? 0), { useGrouping: false }),
    useSysDefaultMinLimit: !merchantGeneralSettings.payInFullMinCheckoutLimit,
    maxLimit: formatAmount(divideBy100(merchantGeneralSettings.payInFullMaxCheckoutLimit ?? 0), { useGrouping: false }),
    useSysDefaultMaxLimit: !merchantGeneralSettings.payInFullMaxCheckoutLimit,
  };
};
